(function () {
    'use strict';

    let tiles = [];

    function getCategory() {
        return pageCategory || '';
    }

    function track(category, action, name) {
        if (String(location.host).includes('localhost') || String(location.host).includes('check24-test.de')) {
            console.log({category: category, action: action, name: name});
        }

        window._paq = window._paq || [];
        window._paq.push(['trackEvent', category, action, name]);
    }

    // hkv:pss (dog) vs kkv:pss (cat) so dog/cat funnels can be analyzed separately.
    function getIpssSeenCategory(el) {
        return el && el.getAttribute('animal-type') === 'cat' ? 'kkv:pss' : 'hkv:pss';
    }

    // One event per IPSS view encoding which tile types are present (1) or not (0).
    function trackIpssSeen(e) {
        tiles = e.detail.data || [];
        const isPresent = (type) => tiles.some(t => t.categoryType === type) ? 1 : 0;
        const getCountByType = (type) => tiles.filter(t => t.categoryType === type).length;

        if (isPresent('lastSearches')) {
            track(getIpssSeenCategory(e.target), 'seen', 'lastsearches:' + getCountByType('lastSearches'));
        }

        if (isPresent('incompleteContract')) {
            track(getIpssSeenCategory(e.target), 'seen', 'dropout:' + getCountByType('incompleteContract'));
        }

        if (isPresent('contract')) {
            track(getIpssSeenCategory(e.target), 'seen', 'contract:' + getCountByType('contract'));
        }

        if (isPresent('offer')) {
            track(getIpssSeenCategory(e.target), 'seen', 'offer:' + getCountByType('offer'));
        }
    }

    // [selector, event, tracking: { category, event, action }]
    const trackingMap = [
        // IPSS - LastSearches
        {
            selector: 'ipss-last-searches', event: 'ipss-last-searches-loaded',
            tracking : (e) => {
                if (e.detail.isSuccessfulFetch) {
                    track(getCategory(), 'seen', 'active:ipss');
                    trackIpssSeen(e);
                }
            }
        },

        // IPSS - select button
        {
            selector: '.ipss-mobile-item[data-category="lastSearches"], ' +
                      '.ipss-item[data-category="lastSearches"]', event: 'click',
            tracking : (e) => {
                const count = tiles.filter(t => t.categoryType === 'lastSearches').length;
                track(getCategory(), 'cta:lastsearch', 'lastsearch:' + count);
            }
        },
        {
            selector: '.ipss-mobile-item[data-category="offer"], ' +
                      '.ipss-item[data-category="offer"]', event: 'click',
            tracking : (e) => {
                const count = tiles.filter(t => t.categoryType === 'offer').length;
                track(getCategory(), 'cta:offer', 'offer:' + count);
            }
        },
        {
            selector: '.ipss-mobile-item[data-category="incompleteContract"], ' +
                      '.ipss-item[data-category="incompleteContract"]', event: 'click',
            tracking : (e) => {
                const count = tiles.filter(t => t.categoryType === 'incompleteContract').length;
                track(getCategory(), 'cta:dropout', 'dropout:' + count);
            }
        },
        {
            selector: '.ipss-mobile-item[data-category="contract"], ' +
                      '.ipss-item[data-category="contract"]', event: 'click',
            tracking : (e) => {
                const count = tiles.filter(t => t.categoryType === 'contract').length;
                track(getCategory(), 'cta:contract', 'contract:' + count);
            }
        },

        // IPSS - delete buttons
        {
            selector: '.ipss-mobile-item[data-category="lastSearches"] .ipss-mobile-item-delete, ' +
                      '.ipss-item[data-category="lastSearches"] .ipss-item-delete', event: 'click',
            tracking : { category: getCategory(), event: 'delete:lastSearches', action: 'cta:delete' }
        },
        {
            selector: '.ipss-mobile-item[data-category="incompleteContract"] .ipss-mobile-item-delete, ' +
                      '.ipss-item[data-category="incompleteContract"] .ipss-item-delete', event: 'click',
            tracking : { category: getCategory(), event: 'delete:incompleteContract', action: 'cta:delete' }
        },
        {
            selector: '.ipss-mobile-item[data-category="contract"] .ipss-mobile-item-delete, ' +
                      '.ipss-item[data-category="contract"] .ipss-item-delete' , event: 'click',
            tracking : { category: getCategory(), event: 'delete:contract', action: 'cta:delete' }
        },
        {
            selector: '.ipss-mobile-item[data-category="offer"] .ipss-mobile-item-delete, ' +
                      '.ipss-item[data-category="offer"] .ipss-item-delete', event: 'click',
            tracking : { category: getCategory(), event: 'delete:offer', action: 'cta:delete' }
        },

        // Application banner (suggest to download check24 mobile app)
        {
            selector: '.c24m-sab', event: 'click',
            tracking : (e) => {
                if (e.target.closest('.c24m-sab-close')) {
                    return;
                }
                track(getCategory(), 'app-banner', 'app-banner:click');
            }
        },
        {
            selector: '.c24m-sab-close', event: 'click',
            tracking : { category: getCategory(), event: 'app-banner:delete', action: 'app-banner' }
        },

        // Product chooser form
        {
            selector: '.product-chooser__form[data-output="main"]', event: 'submit',
            tracking : { category: getCategory(), event: 'cta:compare', action: 'cta:main' }
        },
        {
            selector: '.product-chooser__form[data-output="mini"]', event: 'submit',
            tracking : { category: getCategory(), event: 'cta:compare', action: 'cta:mini' }
        },
        {
            selector: '.product-chooser__sticky-bar button', event: 'click',
            tracking : { category: getCategory(), event: 'cta:compare', action: 'cta:sticky' },
        },

        // Area chooser form
        {
            selector: '.area-chooser-form', event: 'submit',
            tracking : (e) => {
                if (e.target.dataset.sticky === 'true') {
                    track(getCategory(), 'cta:sticky', 'cta:compare');
                    return;
                }
                if (e.target.dataset.output === 'mini') {
                    track(getCategory(), 'cta:mini', 'cta:compare');
                    return;
                }
                track(getCategory(), 'cta:main', 'cta:compare');
            }
        },

        // TV animal chooser form (the sticky bar submits the same form)
        {
            selector: '.tv-animal-chooser__form', event: 'submit',
            tracking : (e) => {
                track(getCategory(), e.target.dataset.sticky === 'true' ? 'cta:sticky' : 'cta:main', 'cta:compare');
            }
        },

        // Nav contact
        {
            selector: '.c24-contact .content', event: 'mouseenter',
            tracking : { category: 'NavKontakt', event: 'Kontakt_seen_hover', action: 'desktop' }
        },
        {
            selector: '.c24-contact .content', event: 'click',
            tracking : { category: 'NavKontakt', event: 'Kontakt_seen_click', action: 'desktop' }
        },
        {
            selector: '.c24-contact-layer a', event: 'click',
            tracking : { category: 'NavKontakt', event: 'Kontakt_email_clicked', action: 'desktop' }
        },
        {
            selector: '.c24m-contact-icon', event: 'click',
            tracking : { category: 'NavKontakt', event: 'Kontakt_seen_click', action: 'mobile' }
        },
        {
            selector: '.c24m-contact-layer-content a', event: 'click',
            tracking : { category: 'NavKontakt', event: 'Kontakt_email_clicked', action: 'desktop' }
        },
        {
            selector: 'button[data-tracking="compare-form"]', event: 'click',
            tracking: { category: getCategory(), action: 'cta:mini', event: 'cta:compare' }
        }
    ];

    function initMap() {
        trackingMap.forEach(function (entry) {
            document.addEventListener(entry.event, function (e) {
                if (!(e.target instanceof Element)) {
                    return;
                }

                let target = e.target.closest(entry.selector);
                if (!target) {
                    return;
                }

                if (entry.tracking instanceof Function) {
                    entry.tracking(e);
                    return;
                }

                track(entry.tracking.category, entry.tracking.action, entry.tracking.event);
            }, true);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initMap();
    });
})();
